import React, { useState } from 'react';
import { IClientLogsRowData } from '../../../views/developers/ClientLogs';
import { getFormattedDate } from '../../../utils/utilities';
import { ClientsLogsTableRowAdditionalData } from './ClientsLogsTableRowAdditionalData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import clsx from 'clsx';
import { WhisperComponent } from '../page-components/WhisperComponent';
import { getReasonPhrase } from 'http-status-codes';

interface Props {
	data: IClientLogsRowData;
}

export const ClientsLogsTableRowData = (props: Props): React.ReactElement => {
	const { statusCode, path, type, date, environment, method, name } = props.data;
	const [isAreaCollapsed, setIsAreaCollapsed] = useState<boolean>(false);

	return (
		<>
			<tr onClick={(): void => setIsAreaCollapsed(prev => !prev)} className="cursor-pointer">
				<td>
					<div className="w-10px">
						<FontAwesomeIcon icon={faChevronDown} width={12} className={clsx('transition-rotate', isAreaCollapsed ? 'rotate-0' : 'rotate-minus-90')}/>
					</div>
				</td>
				<td>{method}</td>
				<td>
					{
						statusCode
						 ? (
								<div className='d-flex align-items-center'>
									<div className="me-1 fs-6">{statusCode}</div>
									<WhisperComponent
										isTooltip
										whisperText={getReasonPhrase(statusCode)}
										mainText={
											<FontAwesomeIcon
												icon={faQuestionCircle}
												className="cursor-pointer"
												width={12}
											/>
										}
									/>
								</div>
						) : '-'
					}
				</td>
				<td>
					<div className="fs-6 w-90px">
						{getFormattedDate(date, 'dd MMM, yyyy')}
					</div>
					<div className="fs-8">
						{getFormattedDate(date, 'hh:mm a')}
					</div>
				</td>
				<td className="fs-6">{environment}</td>
				{/*<td className="fs-6">{request}</td>*/}
				<td className="fs-6">{type ? type : '-'}</td>
				<td className="fs-6">{path ? path : '-'}</td>
				<td>{name ? name : '-'}</td>
			</tr>
			{ isAreaCollapsed && <ClientsLogsTableRowAdditionalData isOpen={isAreaCollapsed} data={props.data}/> }
		</>
	);
};
